export default __webpack_public_path__ + "static/media/WHTblackLogo.f06822c1.svg";